import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";

export default class DivisionParserController {
  constructor(options) {
    console.debug("DivisionParserController", { that: this, options });
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.selected = {};
    Object.assign($ctrl, options);
    $ctrl.bus = new ServiceBus();
  }

  submit() {
    const $ctrl = this;
      const IdIn = ($ctrl.divisionIds || "NO_DIVISION_ID").split(/[\s,]+/gi).filter(divisionid => !!divisionid);
    const request = {
      IdIn,
      take: 500,
      fields: "Id"
    };
    $ctrl.bus.send("QueryDivisions.json", request).then(({ data }) => {
      $ctrl.$close(data.results.map(p => p.id));
    });
  }

  $onDestroy() {
    this.bus.dispose();
  }
}
